import {Component, OnInit} from "@angular/core";
import {ApiService} from "../../service/api";
import {StateService} from "../../service/state";
import {MatDialog} from "@angular/material";
import {DetailComponent} from "./detail/detail.component";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {

    public columns = [
        {prop: 'purchasedate'},
        {prop: 'purchasenumber'},
        {prop: 'totalprice'},
        {prop: 'status'}
    ];
    public orders: any = {
        rows: [],
        total: 0
    };

    constructor(public api: ApiService, public state: StateService, public dialog: MatDialog, public router: Router, protected params: ActivatedRoute) {
        params.queryParams.subscribe((p) => {
            if (p['purchase']) {
                this.api.call('/orders/index/detail', {
                    purchase_id: p['purchase']
                }).then((row) => {
                    let d = this.dialog.open(DetailComponent, {
                        data: {
                            row: row.json()
                        },

                    }).afterClosed().subscribe(() => {
                        this.router.navigate(['home']);
                    });
                });
            }
        })

        this.state.getState('user').then((user) => {
            if (user) {
                this.api.call('/orders/index/select', {
                    user: user.user_id,
                    size: 10
                }).then((data) => {
                    this.orders.rows = data.data;
                    this.orders.total = data.total;
                });
            }
        })
    }

    public openDetail(row): void {
        this.dialog.open(DetailComponent, {
            data: {
                row: row
            }
        });
    }

    public totalFee(row): number {
        const shipping = parseFloat(row.shipmentfee);
        const cart = parseFloat(row.carttotal);
        const purchase = parseFloat(row.purchasefee);

        let total = 0.0;
        if (shipping) {
            total += shipping;
        }
        if (cart) {
            total += cart;
        }
        if (purchase) {
            total += purchase;
        }
        return total;
    }

    public getShippingStatus(status): string {
        switch (status) {
            case "1":
                return 'SHIPMENT.LC_SENT';
            case "2":
                return 'SHIPMENT.LC_ABORT';
            default:
                return 'SHIPMENT.LC_PENDING';
        }
    }

    public getShippingStatusClass(status): string {
        switch (status) {
            case "1":
                return 'green';
            case "2":
                return 'red';
            default:
                return '';
        }
    }

    public getPaymentStatus(status): string {
        switch (status) {
            case "1":
                return 'PAYMENT.LC_PAID';
            case "2":
                return 'PAYMENT.LC_ABORT';
            default:
                return 'PAYMENT.LC_PENDING';
        }
    }

    public getPaymentStatusClass(status): string {
        switch (status) {
            case "1":
                return 'green';
            case "2":
                return 'red';
            default:
                return 'PAYMENT.LC_PENDING';
        }
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/orders/orders.component.ts